import { useCallback } from 'react'
import { useCompleteProductTourMutation, useGetCurrentSpaceMemberQuery } from 'api/spaces-api'

export const useCompleteProductTour = (spaceId: number) => {
  const { data: currentSpaceMember } = useGetCurrentSpaceMemberQuery({ spaceId }, { skip: !spaceId })
  const [completeProductTour] = useCompleteProductTourMutation()

  const completeProductTourIfPending = useCallback(() => {
    if (!currentSpaceMember || currentSpaceMember.productTourCompletedAt != null) return

    completeProductTour({ spaceId })
      .unwrap()
      .catch((error) => console.error('Failed to complete product tour', error))
  }, [currentSpaceMember, completeProductTour, spaceId])

  return { completeProductTourIfPending }
}
